export class Coordenadas {
    latitude: string | number;
    longitude: string | number;
    accuracy?: number;

    constructor(that?: Coordenadas) {
        if (that) {
            this.latitude = +that.latitude;
            this.longitude = +that.longitude;
            this.accuracy = +that.accuracy;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/coordenadas.model.ts